import { Link, useLocation } from "react-router-dom";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";

export default function Navbar() {
  const location = useLocation();

  return (
    <nav className="fixed top-0 w-full bg-[#0D1B2A] shadow-md z-50">
      {/* Контейнер */}
      <div className="flex items-center justify-between w-full max-w-4xl mx-auto p-3">

        {/* Переключатель вкладок */}
        <div className="flex flex-1 bg-gray-900 bg-opacity-80 rounded-lg p-1 shadow-md">
          <Link
            to="/"
            className={`flex-1 text-center py-3 rounded-lg text-base md:text-lg font-semibold transition-all duration-300 ${
              location.pathname === "/" 
                ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg scale-105" 
                : "text-gray-300 hover:bg-gray-800"
            }`}
          >
            🏬 Бренды
          </Link>
          <Link
            to="/categories"
            className={`flex-1 text-center py-3 rounded-lg text-base md:text-lg font-semibold transition-all duration-300 ${
              location.pathname === "/categories" 
                ? "bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg scale-105" 
                : "text-gray-300 hover:bg-gray-800"
            }`}
          >
            🏷️ Категории
          </Link>
        </div>

        {/* Кнопка поиска */}
        <Link to="/search" className="bg-gray-900 p-3 ml-4 rounded-lg hover:bg-gray-800 transition-all shadow-md">
          <MagnifyingGlassIcon className="h-8 w-8 text-gray-300 hover:text-white transition duration-200" />
        </Link>

      </div>
    </nav>
  );
}
